/**
 * Central asset URL helpers.
 * Bump ASSET_VERSION whenever you upload new badges or player photos to S3
 * — this forces browsers to fetch the fresh images instead of using cache.
 */
export const ASSET_VERSION = 22;

const S3_BASE    = 'https://breaderzbadges.s3.eu-north-1.amazonaws.com';
export const BADGES_URL  = `${S3_BASE}/Badges`;
export const PLAYERS_URL = `${S3_BASE}/Players`;

export const badgeUrl  = (teamId)   => `${BADGES_URL}/${teamId}.png?v=${ASSET_VERSION}`;
export const playerUrl = (playerId) => `${PLAYERS_URL}/${playerId}.png?v=${ASSET_VERSION}`;

export const WC_IMAGES_URL   = `${S3_BASE}/WC`;
export const wcImageUrl      = (name)     => `${WC_IMAGES_URL}/${name}.jpg?v=${ASSET_VERSION}`;

// WC 2026 player photos — separate high-res folder, avif format
export const WC_PLAYERS_URL  = `${S3_BASE}/WCPLAYERS`;
export const wcPlayerUrl     = (playerId) => `${WC_PLAYERS_URL}/${playerId}.avif?v=${ASSET_VERSION}`;
